import React from 'react'
import {Container} from 'react-bootstrap';
import withAuth from '../components/authHOC';
import Finestable from '../components/FinesTable';

const LoanFinesPage = () => {
    
  return (
       <Container fluid id='users-container'>
       
        <Finestable></Finestable>
    </Container>
  )
}
export default withAuth (LoanFinesPage, ['admin', 'agent'])